export const xaiModels = {
    id: "xai",
    name: "xAI",
    npm: "@ai-sdk/xai",
    doc: "https://docs.x.ai/docs/models",
    env: ["XAI_API_KEY"],
    models: {
        "grok-3-mini-fast-latest": {
            id: "grok-3-mini-fast-latest",
            name: "Grok 3 Mini Fast Latest",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.6,
                output: 4,
                reasoning: 4,
                cache_read: 0.15,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-3-mini-latest": {
            id: "grok-3-mini-latest",
            name: "Grok 3 Mini Latest",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 0.5,
                reasoning: 0.5,
                cache_read: 0.075,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-beta": {
            id: "grok-beta",
            name: "Grok Beta",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-11-01",
            last_updated: "2024-11-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 5,
                output: 15,
                cache_read: 5,
            },
            limit: {
                context: 131072,
                output: 4096,
            },
        },
        "grok-3-fast-latest": {
            id: "grok-3-fast-latest",
            name: "Grok 3 Fast Latest",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 5,
                output: 25,
                cache_read: 1.25,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-3": {
            id: "grok-3",
            name: "Grok 3",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.75,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-3-mini": {
            id: "grok-3-mini",
            name: "Grok 3 Mini",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 0.5,
                reasoning: 0.5,
                cache_read: 0.075,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-2-vision-1212": {
            id: "grok-2-vision-1212",
            name: "Grok 2 Vision (1212)",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-20",
            last_updated: "2024-12-12",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 8192,
                output: 4096,
            },
        },
        "grok-2": {
            id: "grok-2",
            name: "Grok 2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-20",
            last_updated: "2024-08-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-2-vision-latest": {
            id: "grok-2-vision-latest",
            name: "Grok 2 Vision Latest",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-20",
            last_updated: "2024-12-12",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 8192,
                output: 4096,
            },
        },
        "grok-3-latest": {
            id: "grok-3-latest",
            name: "Grok 3 Latest",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.75,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-2-vision": {
            id: "grok-2-vision",
            name: "Grok 2 Vision",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-20",
            last_updated: "2024-08-20",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 8192,
                output: 4096,
            },
        },
        "grok-2-latest": {
            id: "grok-2-latest",
            name: "Grok 2 Latest",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-20",
            last_updated: "2024-12-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-3-fast": {
            id: "grok-3-fast",
            name: "Grok 3 Fast",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 5,
                output: 25,
                cache_read: 1.25,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-2-1212": {
            id: "grok-2-1212",
            name: "Grok 2 (1212)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-12-12",
            last_updated: "2024-12-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "grok-4": {
            id: "grok-4",
            name: "Grok 4",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-07-09",
            last_updated: "2025-07-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                reasoning: 15,
                cache_read: 0.75,
            },
            limit: {
                context: 256000,
                output: 64000,
            },
        },
        "grok-vision-beta": {
            id: "grok-vision-beta",
            name: "Grok Vision Beta",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-11-01",
            last_updated: "2024-11-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 5,
                output: 15,
                cache_read: 5,
            },
            limit: {
                context: 8192,
                output: 4096,
            },
        },
        "grok-3-mini-fast": {
            id: "grok-3-mini-fast",
            name: "Grok 3 Mini Fast",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.6,
                output: 4,
                reasoning: 4,
                cache_read: 0.15,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
    },
};
export default xaiModels;
//# sourceMappingURL=xai.js.map